import { useEffect, useRef, useState } from 'react';

export const useInView = <T extends HTMLElement>(): {
	ref: React.MutableRefObject<T | null>;
	inView: boolean;
} => {
	const [inView, setInView] = useState(false);
	const ref = useRef<T | null>(null);

	const handleIntersect: IntersectionObserverCallback = entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				setInView(true);
			} else {
				setInView(false);
			}
		});
	};

	useEffect(() => {
		const observer = new IntersectionObserver(handleIntersect, { threshold: 0.3 });

		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => {
			if (ref.current) {
				// eslint-disable-next-line react-hooks/exhaustive-deps
				observer.unobserve(ref.current);
			}
		};
	}, [ref]);

	return { ref, inView };
};
